import React, { useEffect, useState } from 'react';
import webgazer from 'webgazer';

import MyCal from './MyCal/MyCal';
import TextContainer from './MyCal/TextContainer';
import GazeCalibrationTextContainer from './MyCal/GazeCalibrationTextContainer';
import { ScoreProvider } from './MyCal/ScoreContext';
import TextScoreContainer from './MyCal/TextScoreContainer';

// Make webgazer available globally (other components use window.webgazer)
window.webgazer = webgazer;
function AttentionVisual() {

  const[intro, setIntro] = useState(true);
  const[startCalibration, setStartCalibration] = useState(false);

  const introFunction = () => {
    setIntro(false);
  };
  const startFunction = () => {
    setStartCalibration(true);
  };
  const goBackIntro = () => {
    setIntro(true);
    setStartCalibration(false);
  };

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const [showScore, setShowScore] = useState(false);
  const leaveApp = () =>  {
    setShowScore(true);
    //  setIntro(true);
     // setStartCalibration(false);
  };

  return (
    <>
    <ScoreProvider>
      <div style={{height: "100vh", backgroundColor:"#b2d8d8"}}>
        {intro && <TextContainer continueApp={introFunction}/> }
        {!startCalibration && !intro && <GazeCalibrationTextContainer contCalibration={startFunction} goBack={goBackIntro}/> }
        {startCalibration &&
        (screenWidth >= 900 ? (
          <MyCal leave={leaveApp}/>
        ) : (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            Your screen width is not large enough. Please use a larger device to access this feature.
          </div>
        ))}
        {showScore && <TextScoreContainer style={{zIndex:9999}}continueApp={introFunction}/> }
        
      </div>
      </ScoreProvider>
    </>
  );
}

export default AttentionVisual;
